import React from 'react';

const Logo = () => {
    return (
        <div className="flex items-center">
            <div className="flex items-baseline">
                <span className="text-4xl font-bold tracking-wide bg-gradient-to-r from-[#006400] via-[#228B22] to-[#006400] bg-clip-text text-transparent">
                    MuslimTree
                </span>
                <span className="ml-2 text-lg font-medium text-gray-600 tracking-wider">.org</span>
            </div>
        </div>
    );
};

export default Logo; 